<template>
  <div class="">
    <ZnBreadcrumb />
    <div
      class="main-content"
      v-title
      data-title="柜机操作记录_试剂采购库存管理系统"
      id="searchLog"
    >
      <div class="search-type">
        <ul>
          <li>
            <div class="search-item">
              <span class="keywords" style="width: 45px">关键字</span>
              <!-- <img src="../../assets/images/searchIcon.png"
               alt=""> -->
<!--              <el-tooltip content="请输入试剂名称/CAS号/试剂编号" placement="top" effect="light">-->
                <el-input
                    type="text"
                    v-model="searchContent"
                    placeholder="请输入搜索内容"
                    prefix-icon="el-icon-search"
                    @keyup.enter.native="getRecord" style="width: 300px"
                >
<!--                180  250 300-->
                  <el-button slot="suffix" @click="structClick" type="primary" style="left:-30px;width: 68px;height: 30px;
                font-size: 10px;
                margin: auto;
                text-align: center;
                line-height: 6px;
                margin-top: 5px;">结构式</el-button>
                </el-input>
              <div
                  v-show="structShow"
                  class="jsme_container"
                  width="620"
                  height="430"
                  id="jsme_container"
                  ref="jsme_container"
              ></div>
<!--              </el-tooltip>-->
            </div>
            <div class="search-item">
              <span style="width: 70px">最近操作人</span>
              <el-select
                v-model="userId"
                placeholder="请选择"
                @change="getRecord()"
                style="width: 140px"
              >
                <el-option label="全部" value=""> </el-option>
                <el-option
                  v-for="(item, index) in operationPerson"
                  :key="index"
                  :label="item.nickName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>

            <div class="search-item">
              <span style="width: 60px">执行动作</span>
              <el-select
                v-model="logType"
                placeholder="请选择"
                @change="getRecord()"
                style="width: 120px"
              >
                <el-option
                  v-for="item in operations"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="block">
              <el-date-picker
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 300px"
                  v-model="queryTime"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
              </el-date-picker>
            </div>
            <div class="search-item" style="margin-left: 10px">
              <el-button type="primary" size="small" class="cursorPointer" @click="searchClick">
                快速查询
                <!-- 
          v-loading.fullscreen.lock="fullscreenLoading" -->
              </el-button>
            </div>
          </li>
          <!-- <li class="last">
            <el-button class="cursorPointer" @click="getRecord">
              快速查询
              
          v-loading.fullscreen.lock="fullscreenLoading"
            </el-button>
          </li> -->
        </ul>
      </div>
      <div class="goods-info">
        <el-table
          height="600px"
          :data="recordList"
          :header-cell-style="{
            background: '#F8FAFC',
            color: 'rgba(0, 0, 0, 0.85)',
            fontWeight: 700,
            height: '54px',
          }"
          border
          style="width: 100%"
        >
          <template slot="empty">
            <img src="../../assets/images/empty.png" class="empty" />
            <p>暂无操作记录</p>
          </template>
          <el-table-column prop="searchContent" label="搜索内容">
          </el-table-column>
          <el-table-column prop="searchContent" label="结构式" width="200">
            <template slot-scope="scope">


              <div class="demo-image__lazy1" style="overflow: auto;position: relative">
<!--                <el-popover-->
<!--                    style="position: absolute;top: 0;left: 0;z-index: 100"-->
<!--                    placement="top-start"-->
<!--                    width="800"-->
<!--                    trigger="hover"-->
<!--                    @show="reagentPropertyFn(scope.row.casNo)"-->
<!--                    :content="scope.row.goodsName"-->
<!--                >-->
<!--                  <div v-loading="reagentPropertyLoading">-->
<!--                    <el-row class="tabelBl">-->
<!--                      <el-col :span="8">-->
<!--                        <div class="tableLeftTextBox tabelBTr">-->
<!--                          <span>密度（Density）</span>-->
<!--                        </div>-->
<!--                      </el-col>-->
<!--                      <el-col :span="14">-->
<!--                        <div class="tableRightTextBox tabelBTr">-->
<!--                        <span v-if="reagentProperty">-->
<!--                          <span v-if="reagentProperty.density">{{reagentProperty.density}}</span>-->
<!--                          <span v-else>暂无</span>-->
<!--                        </span>-->
<!--                          <span v-else>暂无 -</span>-->
<!--                        </div>-->
<!--                      </el-col>-->
<!--                    </el-row>-->
<!--                    <el-row class="tabelBl">-->
<!--                      <el-col :span="8">-->
<!--                        <div class="tableLeftTextBox tabelBTr">-->
<!--                          <span>熔点（Melting Point）</span>-->
<!--                        </div>-->
<!--                      </el-col>-->
<!--                      <el-col :span="14">-->
<!--                        <div class="tableRightTextBox tabelBTr">-->
<!--                        <span v-if="reagentProperty">-->
<!--                          <span v-if="reagentProperty.meltingPoint">{{reagentProperty.meltingPoint}}</span>-->
<!--                          <span v-else>暂无</span>-->
<!--                        </span>-->
<!--                          <span v-else>暂无 -</span>-->
<!--                        </div>-->
<!--                      </el-col>-->
<!--                    </el-row>-->
<!--                    <el-row class="tabelBl">-->
<!--                      <el-col :span="8">-->
<!--                        <div class="tableLeftTextBox tabelBTr">-->
<!--                          <span>沸点（Boiling Point）</span>-->
<!--                        </div>-->
<!--                      </el-col>-->
<!--                      <el-col :span="14">-->
<!--                        <div class="tableRightTextBox tabelBTr">-->
<!--                         <span v-if="reagentProperty">-->
<!--                          <span v-if="reagentProperty.boilingPoint">{{reagentProperty.boilingPoint}}</span>-->
<!--                          <span v-else>暂无</span>-->
<!--                        </span>-->
<!--                          <span v-else>暂无 -</span>-->
<!--                        </div>-->
<!--                      </el-col>-->
<!--                    </el-row>-->
<!--                    <el-row class="tabelBl">-->
<!--                      <el-col :span="8">-->
<!--                        <div class="tableLeftTextBox tabelBTr">-->
<!--                          <span>闪点（Flash Point）</span>-->
<!--                        </div>-->
<!--                      </el-col>-->
<!--                      <el-col :span="14">-->
<!--                        <div class="tableRightTextBox tabelBTr">-->
<!--                        <span v-if="reagentProperty">-->
<!--                          <span v-if="reagentProperty.flashPoint">{{reagentProperty.flashPoint}}</span>-->
<!--                          <span v-else>暂无</span>-->
<!--                        </span>-->
<!--                          <span v-else>暂无 -</span>-->
<!--                        </div>-->
<!--                      </el-col>-->
<!--                    </el-row>-->
<!--                    <el-row class="tabelBl">-->
<!--                      <el-col :span="8">-->
<!--                        <div class="tableLeftTextBox tabelBTr tableBB">-->
<!--                          <span>安全性（Safety and Hazards）</span>-->
<!--                        </div>-->
<!--                      </el-col>-->
<!--                      <el-col :span="14">-->
<!--                        <div class="tableImagesBox tabelBTr tableBB">-->
<!--                        <span v-if="reagentProperty">-->
<!--                          <div class="">-->
<!--                          <span v-if="reagentProperty.safetyAndHazards == undefined">暂无</span>-->
<!--                          <div class="Safety" v-else>-->
<!--                            <el-image-->
<!--                                v-for="(ite, index) in reagentProperty.safetyAndHazards"-->
<!--                                :src="ite"-->
<!--                                :key="index"-->
<!--                                alt=""-->
<!--                                style="width: 32px; height: 32px"-->
<!--                                :preview-src-list="reagentProperty.safetyAndHazards"-->
<!--                            />-->
<!--                          </div>-->
<!--                      </div>-->
<!--                        </span>-->
<!--                          <span v-else>暂无 -</span>-->
<!--                        </div>-->
<!--                      </el-col>-->
<!--                    </el-row>-->
<!--                  </div>-->
<!--                  <button slot="reference" class="wx_btn">物性</button>-->
<!--                </el-popover>-->
<!--                -->
                <el-image
                    lazy
                    style="width: 100px; height: 100px"
                    :src="scope.row.structImg"
                    :preview-src-list="[`${scope.row.structImg}`]">
                  <div slot="error" class="image-slot" >
                    <div style="width: 100px;height: 100px;line-height: 100px;text-align: center;background-color:#f5f7fa;color: #c0c4cc" >暂无</div>
                  </div>
                </el-image>
              </div>
            </template>

          </el-table-column>
          <el-table-column prop="userName" label="操作人" width="300"> </el-table-column>

          <el-table-column prop="timeCreated" label="操作时间" width="240"> </el-table-column>
          <el-table-column label="执行动作" width="300">
            <template slot-scope="scope">
              <span v-if="scope.row.logType == 1">首页搜索</span>
              <span v-if="scope.row.logType == 2">库存搜索</span>
            </template>
          </el-table-column>
        </el-table>

        <!-- <Pagination
          :dataTotal="total"
          :totalpage="totalpage"
          :pagesize="searchData.pageSize"
          @changePage="changePage"
        ></Pagination> -->
        <el-pagination
          style="float: right"
          :pager-count="5"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.currentPage"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      structShow:false,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      userId: null,
      operationPerson: [],
      orderStatus: "",
      auditStatus: "",
      searchContent: "",
      startTime: '',
      endTime: '',
      queryTime: [],
      code: null,
      // （1:入库，2:归还，3：借用，4:取出，5:移除，6:删除）'
      operations: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 1,
          label: "首页搜索",
        },
        {
          value: 2,
          label: "库存搜索",
        }
      ],
      id: "",
      value: "",
      num: 1,
      radio: "1",
      content: "",
      recordList: [],
      searchData: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      totalpage: 0,
      //柜机列表
      cabList: [{ value: 0, label: "全部" }],
      //选中柜机id
      cabId: 0,
      //操作
      logType: null,
      itemLoading:null,
      lastSearchType:null,
    };
  },
  created() {
    this.getCabs();
    this.getRecord();
    this.getOperationUser();
  },
  mounted() {
    if (location.href.indexOf("#reloaded") == -1) {
      location.href = location.href + "#reloaded";
      location.reload();
    }
    document.getElementById("searchLog").addEventListener("click",(e)=>{
      if(e.target.innerText!="结构式" && this.$refs.jsme_container!=undefined && !this.$refs.jsme_container.contains(e.target)){
        this.structShow = false
      }
    })
  },
  methods: {
    //加载动画
    openLoadingAnimate(ele){
      this.itemLoading  = this.$loading({
        lock:true,
        text:"正在加载",
        spinner:"el-icon-loading",
        background:"#f5f7fac4",
        target:document.querySelector("#searchLog")
      })
    },
    //关闭动画
    closeLoadingAnimate(){
      this.itemLoading.close();
    },

    structClick(){
      this.structShow = !this.structShow
    },
    fullscreenLoading() {},

    // 分页 size 改变
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.searchData.pageNum = this.page.currentPage;
      this.searchData.pageSize = this.page.pageSize;
      this.getRecord();
    },
    // 当前 页码 改变
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.searchData.pageNum = this.page.currentPage;
      this.searchData.pageSize = this.page.pageSize;
      this.getRecord();
    },
    // 获取操作人
    getOperationUser() {
      this.$apiFetch.get(`/lockerUser/queryUserListNoPage`).then((res) => {
        this.operationPerson = res.data;
      });
    },

    //获取柜机
    getCabs() {
      this.$apiFetch
        .get(`/lockerCabinet/queryAvailableCabList`, {
          cabName: this.searchCab,
        })
        .then((res) => {
          res.data.map((item) => {
            this.cabList.push({ value: item.id, label: item.cabName });
          });
          // this.cabList.unshift({value:0,label:'全部'})
        });
    },
    // 快速查询点击
    searchClick(){
      this.lastSearchType = this.structShow==true?"smiles":"input"
      this.getRecord();
    },
    //获取记录
    getRecord() {
      this.openLoadingAnimate("searchLog");
      this.startTime = '';
      this.endTime = '';
      if(null != this.queryTime && this.queryTime.length > 0){
        this.startTime = this.queryTime[0];
        this.endTime = this.queryTime[1];
      }
      const { searchContent, logType, userId,startTime,endTime } = this;
      const { pageSize, pageNum } = this.searchData;
      let searchType = this.structShow==true?"smiles":"input"
      let params = {
        searchContent,
        pageSize,
        pageNum,
        logType,
        userId,
        startTime,
        endTime,
        searchType,
      };
      if(searchType == "smiles" || this.lastSearchType == "smiles"){
        params.searchContent = window.JSApplet.smiles();
        this.lastSearchType = "smiles";
      }
      console.log("user_id = ",params)
      this.$apiFetch.get(`/searchLog/select`, params).then((res) => {
        this.recordList = res.data.list;
        this.total = res.data.total;
        this.totalpage = res.data.pages;
        this.closeLoadingAnimate("searchLog");
      }).catch(error=>{
        this.closeLoadingAnimate();
      });
    },
    changePage(data) {
      this.searchData.pageNum = data;
      this.getRecord();
    },
  },
};
</script>
<style lang="less" scoped>
.main {
  background-color: #ffffff;
}

/deep/ .el-table {
  //margin-top: 20px;
  border-radius: 4px 4px 0 0;
}
.search-type {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 4px 4px 0 0;
  border-bottom: 1px solid #eef2f8;
  li{
    display: flex;
    .search-item{
      display: flex;
      align-items: center;
      margin-right: var(--zng-gap);
      &:last-child{
        margin-right: 0;
      }
      span{
        display: block;
        margin-right: 10px;
      }
      .el-input{
        width: 320px;
      }
    }
  }
  // ul {
  //   li {
  //     float: left;
  //     position: relative;
  //     /deep/ .el-select {
  //       margin-right: 20px;
  //     }
  //     img {
  //       width: 14px;
  //       display: inline-block;
  //       position: relative;
  //       top: 2px;
  //       left: 23px;
  //     }
  //     input {
  //       width: 380px;
  //       height: 36px;
  //       border-radius: 4px;
  //       border: 1px solid #cccccc;
  //       padding-left: 28px;
  //     }
  //     button {
  //       width: 98px;
  //       height: 36px;
  //       background: #478aff;
  //       border-radius: 4px;
  //       font-size: 12px;
  //       color: #ffffff;
  //       margin-left: 12px;
  //     }
  //   }
  //   li.last {
  //     margin-left: 100px;
  //   }
  // }
}
.goods-info {
  padding: 20px;
  background-color: #ffffff;

  .empty {
    width: 196px;
    margin-top: 38px;
    height: unset;
  }
}
.jsme_container{
  position: absolute;
  top: 190px;
  left: 295px;
  width: 400px;
  height: 300px;
  // background: #ccc;
  //border: 1px solid #ccc;
  z-index: 99;
}
</style>
